/** A vertical Flexbox, filling all the space (flex === 1), and providing flex to children */

import type { HTMLAttributes, Ref } from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const VBox = ({ style, ref, ...props }: HTMLAttributes<HTMLDivElement> & { ref?: Ref<any> }) => (
  <div
    ref={ref}
    style={{
      display: 'flex',
      flexDirection: 'column',
      ...style,
    }}
    {...props}
  />
)
